
const types = {

    HTTP_PENDING_EVENT: 'HTTP_PENDING_EVENT',
    HTTP_ERROR_EVENT: 'HTTP_ERROR_EVENT',
    HTTP_SUCCESS_EVENT: 'HTTP_SUCCESS_EVENT',

   
}
const actions = {
    //HTTP
    startHTTPRequest: () => ({
        type: types.HTTP_PENDING_EVENT,
    }),
    stopHTTPRequestError: (error) => ({
        type: types.HTTP_ERROR_EVENT,
        error: error
    }),
    stopRequestSuccess: (payload) => ({
        type: types.HTTP_SUCCESS_EVENT,
        payload: payload
    }),

    
}



export { types, actions };
